<template>
  <div class="breadcrumbs-sticky">
    <v-container class="py-0">
      <v-breadcrumbs :items="getItems">
        <template v-slot:divider>
          <v-icon size="18">mdi-chevron-left</v-icon>
        </template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="item.to"
            class="top-breadcrumb"
            active-class="active"
            :target="item.target"
            :disabled="item.disabled"
            @click="logMixPanelData(item)"
          >
            <v-icon v-if="item.icon" size="18">{{ item.icon }}</v-icon>
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { logMixPanelEvent, mixPanelEvent } from '../../utils/mixpanel';

export default {
  name: 'PageBreadCrumbs',
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('user', ['userId', 'activeTripId', 'getLocationCoordinates']),
    getItems() {
      return [
        {
          icon: '',
          disabled: false,
          to: '/'
        },
        ...this.breadcrumbs
      ];
    }
  },
  methods: {
    logMixPanelData(item) {
      logMixPanelEvent(
        mixPanelEvent.breadCrumbHome,
        {
          userId: this.userId,
          activeTripId: this.activeTripId,
          data: item.text,
          distinct_id: this.userId
        },
        this.getLocationCoordinates
      );
    }
  }
};
</script>
<style lang="scss">
@import 'src/scss/utils/__utils';
/*
 * Vuetify 3 renamed the breadcrumb classes (v-breadcrumbs__divider ->
 * v-breadcrumbs-divider, v-breadcrumbs__item -> v-breadcrumbs-item), so the
 * v2-era rules here stopped matching and the defaults took over: 8px either
 * side of the chevron, 4px either side of every item, plus a padded empty
 * "home" item — which is the gap and the drift the mobile screenshot shows.
 */
.v-application {
  .v-breadcrumbs {
    padding: 16px 0;
    font-weight: 600;
    align-items: center;
    .v-breadcrumbs-divider {
      padding: 0;
      display: inline-flex;
      align-items: center;
    }
    .v-breadcrumbs-item {
      padding: 0;
    }
    li.top-breadcrumb,
    .v-breadcrumbs-item.top-breadcrumb {
      align-items: center;
      display: inline-flex;
      font-size: 16px;
      font-weight: 700;
      a {
        color: $primary;
        &:hover {
          color: $light;
        }
      }
    }
  }
  .v-breadcrumbs-item--link,
  a.v-breadcrumbs-item {
    color: $light;

    .v-icon {
      color: $border;
      transition: $transition;
    }

    &:not(.v-breadcrumbs-item--disabled):hover {
      color: $primary;

      .v-icon {
        color: $primary;
      }
    }
  }
  /* v2 coloured the current page's crumb; v3 fades it with opacity instead */
  .v-breadcrumbs-item--disabled {
    color: $text;
    opacity: 1;
  }
}

.breadcrumbs-sticky {
  position: sticky;
  background-color: #fff;
  z-index: 5;
  top: $header-height;

  @include query-767 {
    top: $header-height-m;
  }

  .page-details & {
    position: static;
  }
}
</style>
